import script from "./AdminModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminModal.vue?vue&type=script&setup=true&lang=js"

import "./AdminModal.vue?vue&type=style&index=0&id=4af17103&lang=scss&scoped=true"
import "./AdminModal.vue?vue&type=style&index=1&id=4af17103&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4af17103"]])

export default __exports__